import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HOSPITAL, INDIVIDUAL, NURSE } from '@constants/constants';
import {
    adminCreateUser,
    adminUpdateUser,
    deleteS3Object,
    updateUser,
} from '@utils/utils';
import {
    INDIVIDUAL_USER_PATH,
    HOSPITAL_USER_PATH,
    NURSE_PATH,
    NURSE_USER_PATH,
} from '@constants/routes';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { useParams, Link } from 'react-router-dom';
import { IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5';
import SharpeInfoIcon from '@components/SvgComponents/SharpInfoIcon';
import { useAppSelector } from '@store/hooks';
import { useAppDispatch } from '@store/hooks';
import { setUserRole } from '@store/reducers/auth/signupSlice';
import { useTranslation } from 'react-i18next';
import HospitalForm from './Form/HospitalForm';
import NurseForm from './Form/NurseForm';
import IndividualForm from './Form/IndividualForm';
import {
    PutItemCommand,
    DynamoDBClient,
    GetItemCommand,
} from '@aws-sdk/client-dynamodb';
import { v4 as uuidv4 } from 'uuid';
import {
    S3Client,
    PutObjectCommand,
    ObjectCannedACL,
    ServerSideEncryption,
    GetObjectCommand,
} from '@aws-sdk/client-s3';
import {
    AdminGetUserCommand,
    CognitoIdentityProviderClient,
} from '@aws-sdk/client-cognito-identity-provider';
import ErrorMessage from '@components/Error/ErrorMessage';

import awsConfig from '../amplifyconfiguration.json';
import { ConsoleLogger } from 'aws-amplify/utils';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { addUUIDSegmentToFilename, getUserAttributes } from '@utils/authUtils';
import {
    DEVICE_ID,
    TENANT_ID,
    USER_MOBILE_NUMBER,
    USER_NAME,
} from '@constants/cognitoAttributes';
import { checkDeviceIdExists } from '@utils/deviceUtils';
import { generateUniqueTimestamp } from '@utils/sharedUtils';
import { dbClient, s3Client } from '@utils/awsClients';
import {
    DEVICE_TABLE,
    HOSPITAL_INFO_TABLE,
    HOSPITALS_TABLE,
    USER_INFO_TABLE,
} from '@constants/dynamoDBTableName';
import { useAuditLog } from '../contexts/AuditLogContext';
import Swal from 'sweetalert2';
const MySwal = Swal;

const UserUpdate: React.FC = () => {
    // const [name, setName] = useState('');
    // const [email, setEmail] = useState('');
    // const [mobileNo, setMobileNo] = useState('');
    // const [password, setPassword] = useState('');
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const dispatch = useAppDispatch();
    const email = useAppSelector((state) => state.signup.email);
    const mobileNumber = useAppSelector((state) => state.signup.mobileNumber);
    const password = useAppSelector((state) => state.signup.password);
    const deviceUniqueID = useAppSelector(
        (state) => state.signup.deviceUniqueID
    );
    const oldDeviceUuid = useAppSelector((state) => state.signup.oldDeviceUuid);
    const oldDeviceId = useAppSelector((state) => state.signup.oldDeviceId);
    const userEmail = useAppSelector((state) => state.signup.email);
    const oldUserEmail = useAppSelector((state) => state.signup.old_email);
    const UserMobileNumber = useAppSelector(
        (state) => state.signup.mobileNumber
    );
    const userPassword = useAppSelector((state) => state.signup.password);
    const userDeviceUniqueID = useAppSelector(
        (state) => state.signup.deviceUniqueID
    );
    const userRole = useAppSelector((state) => state.signup.userRole);
    const userState = useAppSelector((state) => state.signup.userState);
    const userName = useAppSelector((state) => state.signup.name);
    const hospitalName = useAppSelector((state) => state.signup.hospital_name);
    const hospitalBranchName = useAppSelector(
        (state) => state.signup.hospital_branch
    );
    const adminHospitalName = useAppSelector((state) => state.signup.name);
    const hospitalID = useAppSelector((state) => state.signup.hospital_id);
    const hospitalWebsite = useAppSelector(
        (state) => state.signup.hospital_website
    );
    const hospitalEmailID = useAppSelector((state) => state.signup.email_id);
    const hospitalContactNumber = useAppSelector(
        (state) => state.signup.contact_no
    );
    const hospitalGST = useAppSelector((state) => state.signup.gst_no);
    const logo = useAppSelector((state) => state.signup.logo);
    const logo_name = useAppSelector((state) => state.signup.logo_name);
    const old_logo_name = useAppSelector((state) => state.signup.old_logo_name);
    const logo_url = useAppSelector((state) => state.signup.logo_url);
    const logo_type = useAppSelector((state) => state.signup.logo_type);
    const userAddressOne = useAppSelector((state) => state.signup.address_one);
    const userAddressTwo = useAppSelector((state) => state.signup.address_two);
    const userCity = useAppSelector((state) => state.signup.city);
    const userCountry = useAppSelector((state) => state.signup.country);
    const userPincode = useAppSelector((state) => state.signup.pincode);
    const userTable_id = useAppSelector((state) => state.signup.userTableID);
    const hospitalUserTable_id = useAppSelector(
        (state) => state.signup.hospitalUserTableID
    );
    const cognitoUserId = useAppSelector((state) => state.signup.cognitoUserId);
    const tenantUuid = useAppSelector(
        (state) => state.login.loggedInUserTenantID
    );
    const hospitalsTableID = useAppSelector(
        (state) => state.signup.hospitalsTableID
    );
    const { t } = useTranslation();
    // const tenantUuid = uuidv4();
    // const hospitalTenantUuid = uuidv4();
    // const hospital_ID = uuidv4();
    // const hospitalUuid = uuidv4();
    // const hospitalInfoUuid = uuidv4();
    // const userInfoUuid = uuidv4();
    const [userID, setUserID] = useState('');
    const loggedInUserID = useAppSelector(
        (state) => state.login.loggedInUserID
    );
    const { addLog } = useAuditLog();

    useEffect(() => {
        if (userRole == '') {
            const pathname = location.pathname;
            // // Check if the pathname matches any of the paths from AppConfig
            // if (pathname.startsWith(HOSPITAL_USER_PATH + '/')) {
            //     navigate(HOSPITAL_USER_PATH);
            // } else if (pathname.startsWith(INDIVIDUAL_USER_PATH + '/')) {
            //     navigate(INDIVIDUAL_USER_PATH);
            // } else if (pathname.startsWith(NURSE_PATH + '/')) {
            //     navigate(NURSE_PATH);
            // }
            // navigate(-1);
            if (pathname.startsWith(HOSPITAL_USER_PATH + '/')) {
                navigate(HOSPITAL_USER_PATH);
            } else if (pathname.startsWith(INDIVIDUAL_USER_PATH + '/')) {
                navigate(INDIVIDUAL_USER_PATH);
            } else if (pathname.startsWith(NURSE_PATH + '/')) {
                navigate(NURSE_PATH);
            } else if (pathname.startsWith(NURSE_USER_PATH + '/')) {
                navigate(NURSE_USER_PATH);
            }
        }
    }, [location.pathname, userRole, navigate]);

    // const formattedDateTime = new Date().toISOString();
    const formattedDateTime = generateUniqueTimestamp();

    const putCommand = async (input: any) => {
        try {
            const command = new PutItemCommand(input);
            const response = await dbClient.send(command);
            // console.log('User added to DynamoDB', response);
            return response;
        } catch (error: any) {
            console.error('Error adding user to DynamoDB:', error);
            let errorMessage = 'Internal Server Error';

            switch (error.name) {
                case 'ConditionalCheckFailedException':
                    errorMessage = 'Conditional check failed';
                    break;
                case 'ProvisionedThroughputExceededException':
                    errorMessage = 'Provisioned throughput exceeded';
                    break;
                case 'ResourceNotFoundException':
                    errorMessage = 'Resource not found';
                    break;
                default:
                    errorMessage = error.message || 'Unexpected error';
            }

            setError(errorMessage);
        }
    };

    const handleSubmit = async (event: React.SyntheticEvent) => {
        event.preventDefault();

        try {
            // if (deviceUniqueID != oldDeviceId) {
            //     try {
            //         const res = await checkDeviceIdExists(deviceUniqueID);
            //         if (res == 'Device ID exists') {
            //             setError(res);
            //             return;
            //         }
            //     } catch (error: any) {
            //         setError(error);
            //     }
            // }

            // const userAttributes = {
            //     [USER_NAME]: userName,
            //     [DEVICE_ID]: deviceUniqueID,
            //     [USER_MOBILE_NUMBER]: mobileNumber,
            // };

            const userAttributes = [
                {
                    Name: 'custom:mobile_number',
                    Value: mobileNumber,
                },
                {
                    Name: 'custom:name',
                    Value: userName,
                },
                {
                    Name: 'custom:device_id',
                    Value: deviceUniqueID ? deviceUniqueID : '',
                },
            ];

            // Only add the email attribute if the old email is not equal to the new email
            // if (oldUserEmail !== email) {
            //     userAttributes.push(
            //         {
            //             Name: 'email',
            //             Value: email,
            //         },
            //         {
            //             Name: 'email_verified',
            //             Value: 'false',
            //         }
            //     );
            // }

            // const attributes = await getUserAttributes();

            // if (typeof attributes !== 'string' && attributes !== null) {
            // const tenantUuid = attributes[TENANT_ID] ?? '';

            const LogoNameUuid = addUUIDSegmentToFilename(logo_name);
            // setUserRole(role);
            // console.log(role); // Use the role as needed

            await adminUpdateUser(email, userAttributes);

            let attributeNames: { [key: string]: string } = {
                '#name': 'name',
                '#address1': 'address1',
                '#address2': 'address2',
                '#city': 'city',
                '#state': 'state',
                '#email': 'email',
                '#mobile_number': 'mobile_number',
                '#country': 'country',
                '#pincode': 'pincode',
                '#modified_by': 'modified_by',
                '#modified_at': 'modified_at',
                // "#tenant_id": "tenant_id",
            };

            let attributeValues: { [key: string]: { S: string } } = {
                ':name': { S: userName },
                ':email': { S: email },
                ':mobile_number': { S: mobileNumber },
                ':address1': { S: userAddressOne },
                ':address2': { S: userAddressTwo },
                ':city': { S: userCity },
                ':state': { S: userState },
                ':country': { S: userCountry },
                ':pincode': { S: userPincode },
                ':modified_by': { S: tenantUuid },
                ':modified_at': { S: formattedDateTime },
                // ":tenant_id": { S: tenantUuid },
            };

            // const UpdateExpression = "SET #name = :name, #address1 = :address1, #address2 = :address2, #city = :city, #state = :state, #country = :country, #pincode = :pincode, #createdAt = :createdAt, #tenant_id = :tenant_id",
            let updateExpression =
                'SET #name = :name, #email = :email, #mobile_number = :mobile_number, #address1 = :address1, #address2 = :address2, #city = :city, #state = :state, #country = :country, #pincode = :pincode, #modified_by = :modified_by, #modified_at = :modified_at';

            if (userRole.toLowerCase() === NURSE.toLowerCase()) {
                attributeNames['#hospital_id'] = 'hospital_id';
                attributeNames['#hospital_name'] = 'hospital_name';
                attributeValues[':hospital_id'] = { S: hospitalID };
                attributeValues[':hospital_name'] = { S: hospitalName };
                updateExpression +=
                    ', #hospital_id = :hospital_id, #hospital_name = :hospital_name';
            }
            if (userRole.toLowerCase() === HOSPITAL.toLowerCase()) {
                attributeNames['#hospital_name'] = 'hospital_name';
                attributeValues[':hospital_name'] = { S: hospitalName };
                updateExpression += ', #hospital_name = :hospital_name';
            }

            // let deviceAttributeNames: { [key: string]: string } = {
            //     '#device_id': 'device_id',
            //     '#modified_by': 'modified_by',
            //     '#modified_at': 'modified_at',
            //     // "#tenant_id": "tenant_id",
            // };

            // let deviceAttributeValues: { [key: string]: { S: string } } = {
            //     ':device_id': { S: deviceUniqueID },
            //     ':modified_by': { S: tenantUuid },
            //     ':modified_at': { S: formattedDateTime },
            //     // ":tenant_id": { S: tenantUuid },
            // };

            // const UpdateExpression = "SET #name = :name, #address1 = :address1, #address2 = :address2, #city = :city, #state = :state, #country = :country, #pincode = :pincode, #createdAt = :createdAt, #tenant_id = :tenant_id",
            // let deviceUpdateExpression =
            //     'SET #device_id = :device_id, #modified_by = :modified_by, #modified_at = :modified_at';
            await updateUser(
                USER_INFO_TABLE,
                userTable_id,
                attributeNames,
                attributeValues,
                updateExpression
            );

            // await updateUser(
            //     DEVICE_TABLE,
            //     oldDeviceUuid,
            //     deviceAttributeNames,
            //     deviceAttributeValues,
            //     deviceUpdateExpression
            // );

            if (userRole.toLowerCase() === HOSPITAL.toLowerCase()) {
                const hospitalAttrabutiesNames = {
                    '#name': 'name',
                    '#address1': 'address1',
                    '#address2': 'address2',
                    '#city': 'city',
                    '#state': 'state',
                    '#country': 'country',
                    '#pincode': 'pincode',
                    '#modified_by': 'modified_by',
                    '#modified_at': 'modified_at',
                    '#hospital_branch': 'hospital_branch',
                    '#hospital_contact': 'hospital_contact',
                    '#hospital_email': 'hospital_email',
                    '#hospital_name': 'hospital_name',
                    '#hospital_website': 'hospital_website',
                    '#hospital_logo': 'hospital_logo',
                    '#gst': 'gst',
                    // "#tenant_id": "tenant_id",
                };

                const hospitalAttributValues = {
                    ':name': { S: userName },
                    ':address1': { S: userAddressOne },
                    ':address2': { S: userAddressTwo },
                    ':city': { S: userCity },
                    ':state': { S: userState },
                    ':country': { S: userCountry },
                    ':pincode': { S: userPincode },
                    ':modified_by': { S: tenantUuid },
                    ':modified_at': { S: formattedDateTime },
                    ':hospital_branch': { S: hospitalBranchName },
                    ':hospital_contact': { S: hospitalContactNumber },
                    ':hospital_email': { S: hospitalEmailID },
                    ':hospital_name': { S: hospitalName },
                    ':hospital_website': { S: hospitalWebsite },
                    ':hospital_logo': { S: LogoNameUuid },
                    ':gst': { S: hospitalGST },
                    // ":tenant_id": { S: tenantUuid },
                };
                const hospitalUpdateExpression =
                    'SET #name = :name, #address1 = :address1, #address2 = :address2, #city = :city, #state = :state, #country = :country, #pincode = :pincode,  #modified_by = :modified_by, #modified_at = :modified_at, #hospital_branch = :hospital_branch, #hospital_contact = :hospital_contact, #hospital_email = :hospital_email, #hospital_name = :hospital_name, #hospital_website = :hospital_website, #hospital_logo = :hospital_logo , #gst = :gst';

                if (logo_name) {
                    if (old_logo_name) {
                        await deleteS3Object(old_logo_name);
                    }
                    await handleUpload(LogoNameUuid);
                }

                const hospitalsAttrabutiesNames = {
                    '#name': 'name',
                    '#address1': 'address1',
                    '#address2': 'address2',
                    '#city': 'city',
                    '#state': 'state',
                    '#country': 'country',
                    '#pincode': 'pincode',
                    '#modified_by': 'modified_by',
                    '#modified_at': 'modified_at',
                    '#hospital_branch': 'hospital_branch',
                    '#hospital_contact': 'hospital_contact',
                    '#hospital_email': 'hospital_email',
                    '#hospital_name': 'hospital_name',
                    '#hospital_website': 'hospital_website',
                    '#hospital_logo': 'hospital_logo',
                    '#gst': 'gst',
                    // "#tenant_id": "tenant_id",
                };

                const hospitalsAttributValues = {
                    ':modified_by': { S: tenantUuid },
                    ':modified_at': { S: formattedDateTime },
                    ':hospital_name': { S: hospitalName },
                    // ":tenant_id": { S: tenantUuid },
                };
                const hospitalsUpdateExpression =
                    'SET #modified_by = :modified_by, #modified_at = :modified_at, #hospital_name = :hospital_name';

                await updateUser(
                    HOSPITALS_TABLE,
                    hospitalsTableID,
                    hospitalsAttrabutiesNames,
                    hospitalsAttributValues,
                    hospitalsUpdateExpression
                );
                await updateUser(
                    HOSPITAL_INFO_TABLE,
                    hospitalUserTable_id,
                    hospitalAttrabutiesNames,
                    hospitalAttributValues,
                    hospitalUpdateExpression
                );
            }
            // }

            addLog(
                'User Updated',
                userTable_id,
                'User',
                loggedInUserID,
                {
                    updatedFields: {
                      name: userName,
                      email: email,
                      mobile_number: mobileNumber,
                      device_id: deviceUniqueID,
                      address1: userAddressOne,
                      address2: userAddressTwo,
                      city: userCity,
                      state: userState,
                      country: userCountry,
                      pincode: userPincode,
                      ...(userRole.toLowerCase() === 'nurse' && {
                        hospital_id: hospitalID,
                        hospital_name: hospitalName
                      }),
                      ...(userRole.toLowerCase() === 'hospital' && {
                        hospital_name: hospitalName,
                        hospital_branch: hospitalBranchName,
                        hospital_contact: hospitalContactNumber,
                        hospital_email: hospitalEmailID,
                        hospital_website: hospitalWebsite,
                        hospital_logo: LogoNameUuid,
                        gst: hospitalGST
                      })
                    }
                  },
                window.location.hostname
            );

            MySwal.fire({
                position: 'top-end', // Position the toast in the top-right corner
                icon: 'success',
                title: 'User data updated successfully',
                showConfirmButton: false,
                timer: 1500,
                toast: true,
                customClass: {
                    popup: 'text-green bg-light_green', // Add custom class to the popup
                },
            });

            backArrow();
        } catch (error: any) {
            // setError(error);
            // setError(error.message || String(error));
            let errorMessage;
            switch (error.name) {
                case 'UserNotFoundException':
                    errorMessage = 'User not found.';
                    break;
                case 'UsernameExistsException':
                    errorMessage = 'Email already exists.';
                    break;
                case 'InvalidParameterException':
                    errorMessage = 'Invalid parameters provided.';
                    break;
                case 'LimitExceededException':
                    errorMessage = 'Limit exceeded.';
                    break;
                case 'InternalErrorException':
                    errorMessage = 'Internal server error.';
                    break;
                default:
                    errorMessage =
                        error.message || 'An unknown error occurred.';
            }
            setError(errorMessage);
        }
    };

    const handleUpload = async (LogoNameUuid: string) => {
        if (!logo_url) {
            // alert('Please select a file first!');
            return;
        }
        const name = LogoNameUuid;
        // const content = data.logoUrl;
        const content = logo_url.split(',')[1]; // Get the base64 part
        // const buffer = Buffer.from(content, 'base64');
        // console.log('buffer', buffer)
        let buffer;
        try {
            const binaryString = atob(content);
            const length = binaryString.length;
            buffer = new Uint8Array(length);
            for (let i = 0; i < length; i++) {
                buffer[i] = binaryString.charCodeAt(i);
            }
        } catch (bufferError) {
            console.error('Error converting base64 to buffer:', bufferError);
            return;
        }
        const type = logo_type;
        const params = {
            Bucket: 'dripsetapplicationstaging',
            Key: name,
            Body: buffer,
            ContentType: type,
            ACL: ObjectCannedACL.private,
        };
        // const params = {
        //     Bucket: 'dripsetapplicationstaging',
        //     Key: logo_name,
        //     Body: logo_url,
        //     ContentType: logo_type,
        //     ACL: ObjectCannedACL.private,
        // };

        try {
            const command = new PutObjectCommand(params);
            const uploadResult = await s3Client.send(command);
            // console.log('File uploaded successfully:', uploadResult);
        } catch (error: any) {
            let errorMessage =
                'There was an error uploading the file. Please try again later.';

            switch (error.name) {
                case 'NoSuchBucket':
                    errorMessage = 'The specified bucket does not exist.';

                    break;
                case 'AccessDenied':
                    errorMessage = 'Access denied.';

                    break;
                case 'InvalidParameterException':
                    errorMessage =
                        'Invalid parameters. Please check the file details and try again.';
                    break;
                case 'NetworkingError':
                    errorMessage =
                        'Network error. Please check your internet connection and try again.';
                    break;
                default:
                    errorMessage =
                        error.message || 'Unexpected error occurred.';
            }

            setError(errorMessage);
        }
    };

    const backArrow = () => {
        // Check if the pathname matches any of the paths from AppConfig
        // if (userRole.to === HOSPITAL) {
        //     navigate(HOSPITAL_USER_PATH);
        // } else if (userRole === INDIVIDUAL) {
        //     navigate(INDIVIDUAL_USER_PATH);
        // } else if (userRole.startsWith(NURSE_PATH + '/')) {
        //     navigate(NURSE_PATH);
        // }
        // const pathname = location.pathname;
        // // console.log(pathname);
        // // Check if the pathname matches any of the paths from AppConfig
        // if (pathname.startsWith(HOSPITAL_USER_PATH + '/')) {
        //     navigate(HOSPITAL_USER_PATH);
        // } else if (pathname.startsWith(INDIVIDUAL_USER_PATH + '/')) {
        //     navigate(INDIVIDUAL_USER_PATH);
        // } else if (pathname.startsWith(NURSE_PATH + '/')) {
        //     navigate(NURSE_PATH);
        // }
        navigate(-1);
    };
    return (
        <div className="mx-auto px-5">
            <div className="font-bold text-black">
                {/* <Link to={HOSPITAL_USER_PATH}> */}
                <div
                    className="flex items-center cursor-pointer"
                    onClick={backArrow}
                >
                    <FaArrowLeftLong className="" />{' '}
                    <h2 className="text-base font-semibold ml-2">{t('edit_user')}</h2>
                </div>
                {/* </Link> */}
            </div>
            {error && <ErrorMessage message={error} />}
            <div className="cart relative mx-auto bg-white rounded-2xl p-5 mt-5 w-11/12">
                <form onSubmit={handleSubmit} className="w-10/12 mx-auto">
                    {userRole == HOSPITAL && <HospitalForm />}

                    {userRole == NURSE && <NurseForm />}

                    {userRole == INDIVIDUAL && <IndividualForm />}
                    <div className="  col-span-2 pb-14 absolute flex -bottom-40 left-1/2 -translate-x-2/4 cursor-pointer justify-center w-full">
                        <button
                            className="bg-primary text-lg text-white py-2  px-4 rounded-lg w-2/6"
                            type="submit"
                        >
                            {t('submit')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UserUpdate;
